/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Credentials_Permissions_View_CredentialsInputs */

const es_components_credentials_permissions_view_credentials = /** @type {(inputs: Components_Credentials_Permissions_View_CredentialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver Permisos`)
};

const en_components_credentials_permissions_view_credentials = /** @type {(inputs: Components_Credentials_Permissions_View_CredentialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View Permissions`)
};

/**
* | output |
* | --- |
* | "View Permissions" |
*
* @param {Components_Credentials_Permissions_View_CredentialsInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_credentials_permissions_view_credentials = /** @type {((inputs?: Components_Credentials_Permissions_View_CredentialsInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Credentials_Permissions_View_CredentialsInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_credentials_permissions_view_credentials(inputs)
	return en_components_credentials_permissions_view_credentials(inputs)
});
export { components_credentials_permissions_view_credentials as "components.credentials.permissions.view_credentials" }